import { render } from "./Token.vue?vue&type=template&id=597ea73f&scoped=true"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"

import "./Token.vue?vue&type=style&index=0&id=597ea73f&scoped=true&lang=css"
import "./Token.vue?vue&type=style&index=1&id=597ea73f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597ea73f"]])

export default __exports__